/* eslint-disable eqeqeq */
import React,{Component}  from 'react';
import{List,InputItem,Button} from 'antd-mobile';
import 'antd-mobile/dist/antd-mobile.css'; 
import 'antd-mobile/lib/date-picker/style'; 
import {connect} from 'dva';
import Loading from "../../Loading";

class ChangePassWord extends Component {
    constructor(props){
        super(props);
        this.state ={
          old_AAA203:'',
          new_AAA203:'',
          confirm_AAA203:'',
          message:null
            
        }
    }
    componentDidMount() {
       
      }
    onChangeOld_AAA203(value){
      this.setState({
        old_AAA203:value
      });
    }
    onChangeNew_AAA203(value){
      this.setState({
        new_AAA203:value
      });
    }
    onChangeConfirm_AAA203(value){
      this.setState({
        confirm_AAA203:value
      });
    }
    submit(){
      if(!this.state.old_AAA203)
        {
            this.setState({
                message:"旧密码必须输入"
            });
            return;
        }
        if(!this.state.new_AAA203)
        {
            this.setState({
                message:"新密码必须输入"
            });
            return;
        }
        if(!this.state.confirm_AAA203)
        {
          this.setState({
            message:"确认密码必须输入"
          });
          return;
        }
        if(this.state.new_AAA203 != this.state.confirm_AAA203)
        {
          this.setState({
            message:"新密码两次输入不一致！"
          });
          return;
        }
        this.props.dispatch({type:"index/ChangePassWord",payload:{
            AAA201:localStorage.getItem("AAA201"),
            AAA203 :this.state.old_AAA203 ,
            new_AAA203 :this.state.new_AAA203
        }}).then(()=>{
            this.setState({
                message:this.props.message
            });
        });
    }
    render(){
        return(
          <div>
          <h1>
           修改密码
           </h1>
          <List>
         
          <InputItem type="password" value={this.state.old_AAA203} onChange={value=>this.onChangeOld_AAA203(value)} placeholder="请输入旧密码..." >旧密码</InputItem>
          <InputItem type="password" value={this.state.new_AAA203} onChange={value=>this.onChangeNew_AAA203(value)} placeholder="请输入新密码..." >新密码</InputItem>
          <InputItem type="password" value={this.state.confirm_AAA203} onChange={value=>this.onChangeConfirm_AAA203(value)} placeholder="请输入确认密码..." >确认密码</InputItem>
          <Loading loading={this.props.loading} />
          </List>
          <h2> {this.state.message}</h2>
          <Button type="primary" loading={this.props.loading} disabled={this.props.loading} onClick={()=>this.submit()} >提交</Button>
   
       
      </div>
      );
    }

}

export default connect(state=>{
  return {
    ...state.index,
    loading: state.loading.global
  }
})(ChangePassWord) ;